import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
const prescriptApp = () => import('../components/page/prescriptApp.vue');
export default new Router({
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/login',
    // component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
  },
  // {
  //   path: '/',
  //   name: 'HelloWorld',
  //   component: HelloWorld
  // },
  {
    path: '/login',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/fail',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/fail.vue'),
    meta: {
      title: '系统维护'
    }
  },
  {
    path: '/rich_detail',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/richDetail.vue'),
    meta: {
      title: '详情'
    }
  },
  {
    path: '/recommend',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/recommend.vue'),
    meta: {
      title: '推荐有礼'
    }
  },
  {
    path: '/register',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/register.vue'),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/review',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/review.vue'),
    meta: {
      title: '复核处方申请'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/home.vue'),
    meta: {
      title: '药康夫'
    }
  },
  {
    path: '/prescriptApp',
    name: 'prescriptApp',
    component: prescriptApp,
    meta: {
      title: '处方申请',
      keepAlive: true
    }
  },
  {
    path: '/apply-list',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/applyList.vue'),
    meta: {
      title: '申请列表'
    }
  },
  {
    path: '/apply-drug',
    name: 'applyDrug',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/applyDrug.vue'),
    meta: {
      title: '申请添加药品'
    }
  },
  // 我的
  {
    path: '/my',
    component: () => import('../components/page/my.vue'),
    meta: {
      title: '个人中心'
    }
  },
  // 药店信息
  {
    path: '/storeInfo',
    component: () => import('../components/page/storeInfo.vue'),
    meta: {
      title: '药店信息'
    }
  },
  // 充值记录
  {
    path: '/rechargeList',
    component: () => import('../components/page/rechargeList.vue'),
    meta: {
      title: '充值记录'
    }
  },
  // 充值记录详情
  {
    path: '/rechargeDetail',
    component: () => import('../components/page/rechargeDetail.vue'),
    meta: {
      title: '充值记录详情'
    }
  },
  {
    path: '/apply-success',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/applySuccess.vue'),
    meta: {
      title: '申请添加药品'
    }
  },
  {
    path: '/appRecordList',
    component: () => import( /* webpackChunkName: "login" */
      '../components/page/appRecordList.vue'),
    meta: {
      title: '处方记录'
    }
  },
  {
    path: '/docMangeList',
    name: 'docMangeList',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/docMangeList.vue'),
    meta: {
      title: '药师管理'
    }
  },
  {
    path: '/faceRecofnition',
    name: 'faceRecofnition',
    component: () => import( /* webpackChunkName: "login" */ '../components/doctor/faceRecofnition.vue'),
    meta: {
      title: '完善人脸信息'
    }
  },
  {
    path: '/sign',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/sign.vue'),
    meta: {
      title: '添加药师'
    }
  },
  {
    path: '/forget-password1',
    component: () => import( /* webpackChunkName: "login" */
      '../components/page/ForgetPassword1.vue'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/forget-password2',
    component: () => import( /* webpackChunkName: "login" */
      '../components/page/ForgetPassword2.vue'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/pay-type',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/payType.vue'),
    meta: {
      title: '账户充值'
    }
  },
  {
    path: '/storeQrcode',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/storeQrcode.vue'),
    meta: {
      title: '门店二维码'
    }
  },
  {
    path: '/scan',
    component: () => import( /* webpackChunkName: "login" */ '../components/common/scan.vue'),
    meta: {
      title: '门店二维码'
    }
  },
  {
    path: '/record-detail',
    component: () => import( /* webpackChunkName: "login" */ '../components/page/recordDetail.vue'),
    meta: {
      title: '详情'
    }
  },
  // 测试
  {
    path: '/test',
    component: () => import( /* webpackChunkName: "login" */ '../components/common/test.vue'),
    meta: {
      title: '详情'
    }
  },
  // 药师账号
  {
    path: '/doctorAdministration',
    name: 'doctorAdministration',
    component: () => import( /* webpackChunkName: "login" */
      '../components/doctor/doctorAdministration.vue'),
    meta: {
      title: '药师管理'
    }
  },
  // 个人设置
  {
    path: '/personalSettings',
    component: () => import( /* webpackChunkName: "login" */
      '../components/doctor/personalSettings.vue'),
    meta: {
      title: '个人设置'
    }
  },
  // 处方记录
  {
    path: '/prescriptionRecord',
    component: () => import( /* webpackChunkName: "login" */
      '../components/doctor/prescriptionRecord.vue'),
    meta: {
      title: '处方记录'
    }
  },
  // 审核
  {
    path: '/examine',
    component: () => import( /* webpackChunkName: "login" */
      '../components/doctor/examine.vue'),
    meta: {
      title: '审核处方单'
    }
  },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js